import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ServicesOverview from './components/ServicesOverview';
import HowItWorks from './components/HowItWorks';
import WeeklyMenu from './components/WeeklyMenu';
import CorporateSolutions from './components/CorporateSolutions';
import SubscriptionPlans from './components/SubscriptionPlans';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import MobileApp from './components/MobileApp';
import DeliveryMap from './components/DeliveryMap';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ContactForm from './components/ContactForm';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <ServicesOverview />
      <HowItWorks />
      <WeeklyMenu />
      <CorporateSolutions />
      <SubscriptionPlans />
      <Benefits />
      <Testimonials />
      <MobileApp />
      <DeliveryMap />
      <CTABanner />
      <ContactForm />
      <Footer />
    </div>
  );
}